import styled from 'react-emotion';

interface ITitleProps {
  size?: string;
  color?: string;
  noShadow?: true;
}

const Title = styled('span')`
  font-size: ${(props: ITitleProps) => props.size || '3rem'};
  color: ${(props: ITitleProps) => props.color || 'rgb(252, 182, 18)'};
  text-shadow: ${(props: ITitleProps) =>
    props.noShadow
      ? 'none'
      : `0 0 0 black, 
        0 1px 0 black, 
        1px 0 0 black, 
        1px 1px 0 black,    
        1px 2px 0 black, 
        2px 1px 0 black, 
        2px 2px 0 black`};
  text-align: center;
  font-weight: bold;
`;

export default Title;



// WEBPACK FOOTER //
// ./src/components/Title.ts